export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function currentFyStart() {
  const d = new Date();
  const year = d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1;
  return `${year}-04-01`;
}
